export const fetchDetail_Url =
  window.location.hostname === "localhost"
    ? "https://rainfrog-api.aleaspeaks.com/api/"
    : window.location.hostname === "rainfrog.aleaspeaks.com"
      ? "https://rainfrog-api.aleaspeaks.com/api/"
      : "https://api.rainfrog.monetyz.com/api/";

export const fileUrl =
  window.location.hostname === "localhost"
    ? "https://rainfrog-api.aleaspeaks.com/"
    : window.location.hostname === "rainfrog.aleaspeaks.com"
      ? "https://rainfrog-api.aleaspeaks.com/"
      : "https://api.rainfrog.monetyz.com/";
